// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ub-0";